import React from "react"
import { CarouselComponent } from "../CarouselComponent"

export const PhiloWelcomeComponent = () => {
  return (
    <CarouselComponent bgPosition="0% 50%" images={["/images/Philo/landing_desktop.jpg"]}>
     <div className="row">
         <div className="col mx-auto">
           <h1 className="text-center">Submit a request for your Philo offer below.</h1>
         </div>
      </div>
      <img className="d-none d-md-block"style={{position: "absolute", right: "0px", bottom: "40%"}} src={"images/Philo/philo_logo_pill.png"} alt="philo logo"/>
    </CarouselComponent>
  )
}
